// @flow
import { ImageSideButton, Block, addNewBlock } from 'medium-draft';
import axios from 'axios';

export default class EditorImageButton extends ImageSideButton {
  state = {};

  async onChange(e) {
    try {
      const file = e.target.files[0];

      const uploadURL = `https://api.cloudinary.com/v1_1/planes/upload`;
      const fd = new FormData();
      fd.append('upload_preset', 'munity_editor');
      fd.append('tags', 'browser_upload'); // Optional - add tag for image admin in Cloudinary
      fd.append('file', file);
      const config = {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        onUploadProgress: function(progressEvent) {
          const progress = Math.round(
            progressEvent.loaded * 100.0 / progressEvent.total
          );

          console.log({ progress });
        },
      };

      const { data: { secure_url: url } } = await axios.post(
        uploadURL,
        fd,
        config
      );
      this.props.setEditorState(
        addNewBlock(this.props.getEditorState(), Block.IMAGE, {
          src: url,
        })
      );
    } catch (e) {
      window.alert('Something went wrong');
    }
    this.props.close();
  }
}



// WEBPACK FOOTER //
// ./src/pages/proposal/components/editor-image-button/index.js